import "./BlogSidebar.css";

function BlogSidebar() {
  return (
    <div className="blog-sidebar">
      <ul>
        <li>Over het platform</li>
        <li>Mijn account</li>
        <li>Respons</li>
        <li>Vragenlijsten</li>
      </ul>
    </div>
  );
}

export default BlogSidebar;